import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useLoadingStore = defineStore('loading', () => {
  const pendingCount = ref(0);
  const scopes = ref({});

  const isLoading = computed(() => pendingCount.value > 0);

  const hasScopeLoading = (scope) => Number(scopes.value[scope] || 0) > 0;

  const start = (scope = 'global') => {
    pendingCount.value += 1;
    scopes.value = {
      ...scopes.value,
      [scope]: Number(scopes.value[scope] || 0) + 1,
    };
  };

  const finish = (scope = 'global') => {
    pendingCount.value = Math.max(0, pendingCount.value - 1);
    const current = Number(scopes.value[scope] || 0);
    const next = { ...scopes.value };
    if (current <= 1) {
      delete next[scope];
    } else {
      next[scope] = current - 1;
    }
    scopes.value = next;
  };

  const reset = () => {
    pendingCount.value = 0;
    scopes.value = {};
  };

  return {
    pendingCount,
    scopes,
    isLoading,
    hasScopeLoading,
    start,
    finish,
    reset,
  };
});
